import { render, staticRenderFns } from "./CorporationG.vue?vue&type=template&id=37ff8728&scoped=true"
import script from "./CorporationG.vue?vue&type=script&lang=js"
export * from "./CorporationG.vue?vue&type=script&lang=js"
import style0 from "./CorporationG.vue?vue&type=style&index=0&id=37ff8728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff8728",
  null
  
)

export default component.exports